<template>
    <ob1-cards additional-classes="full-height">
        <div class="p-1 text-center h-100 d-flex flex-column align-items-stretch justify-content-between">
            <div>
                <div v-if="title" class="h3 mb-0 mobile-infos navads" v-html="title" />
                <p v-if="text" class="lead mb-0 infos-price navads mt--1 text-gray3 fw-bold" v-html="text" />
            </div>
            <div class="p-1 infos-advantage navads">
                <div class="img-container">
                    <ob1-picture
                        v-if="visual"
                        :visual="visual"
                    />
                </div>
            </div>
            <ob1-boutons
                v-if="url !== undefined && urlAccessWording !== undefined"
                class="pb-1 mx-auto"
                :is-secondary="true"
                :is-button="false"
                :label="urlAccessWording"
                :href="url"
                target="_blank"
                @ob1-boutons-click="sendTmsForNavads"
            />
        </div>
    </ob1-cards>
</template>

<script>
export default {
    name: "SelectorAnimation",
    props: {
        title: {
            type: String,
            default: undefined
        },
        titleForTag: {
            type: String,
            default: undefined
        },
        text: {
            type: String,
            default: undefined
        },
        urlAccessWording: {
            type: String,
            default: undefined
        },
        url: {
            type: String,
            default: undefined
        },
        visual: {
            type: Object,
            default: undefined
        },
    },
    methods: {
        sendTmsForNavads() {
            Tms.link({
                category: this.titleForTag,
                action: this.urlAccessWording,
                label: this.url
            });
        }
    }
}
</script>
